
// import * as echarts from 'echarts'
// import * as echarts from './echarts'
import { Component, Vue } from 'vue-property-decorator'
import MemberCenterTitle from './HomeNewsTitle.vue'
import { mapOption } from './MemberCenter'
// import ChinaProvinceJson from './ChinaProvinceJson.json'
import { MapManager } from '@/pages/index/manages/mapManager'
import axios from 'axios'
import { MapService } from '../services/mapservice'

@Component({
  components: {
    MemberCenterTitle
  }
})
export default class extends Vue {
  private manager = new MapManager(new MapService())
  private myChart: any = null
  private dialogVisible = false
  private showUnitList = false
  private name = ''
  private memberTotal = 0
  private standingDirectorUnit = 0
  private councilMembers = 0
  private memberUnit = 0
  private showMember = true

  async mounted () {
    // await this.manager.getMapData()
    // axios.get('/china.json').then((res: any) => {
    //   echarts.registerMap('china', res.data)
    //   if (!this.myChart) {
    //     this.myChart = echarts.init(document.getElementById('map') as any)
    //   }
    //   // 注册
    //   // console.log(this.manager.mapData)
    //   const mapData = mapOption.series
    //   mapData.filter((item: any) => '会员总数'.includes(item.name))[0].data = this.manager.mapData.memberTotal as any
    //   mapData.filter((item: any) => '常务理事单位'.includes(item.name))[0].data = this.manager.mapData.standingDirectorUnit as any
    //   mapData.filter((item: any) => '理事单位'.includes(item.name))[0].data = this.manager.mapData.councilMembers as any
    //   mapData.filter((item: any) => '会员单位'.includes(item.name))[0].data = this.manager.mapData.memberUnit as any
    //   this.myChart.setOption(mapOption)
    //   console.log(mapOption)
    //   this.myChart.on('click', (params: any) => {
    //     console.log(params)
    //     this.memberTotal = this.manager.mapData.memberTotal.filter((item: any) => params.name.includes(item.name))[0] !== undefined ? this.manager.mapData.memberTotal.filter((item: any) => params.name.includes(item.name))[0].value : 0
    //     this.standingDirectorUnit = this.manager.mapData.standingDirectorUnit.filter((item: any) => params.name.includes(item.name))[0] !== undefined ? this.manager.mapData.standingDirectorUnit.filter((item: any) => params.name.includes(item.name))[0].value : 0
    //     this.councilMembers = this.manager.mapData.councilMembers.filter((item: any) => params.name.includes(item.name))[0] !== undefined ? this.manager.mapData.councilMembers.filter((item: any) => params.name.includes(item.name))[0].value : 0
    //     this.memberUnit = this.manager.mapData.memberUnit.filter((item: any) => params.name.includes(item.name))[0] !== undefined ? this.manager.mapData.memberUnit.filter((item: any) => params.name.includes(item.name))[0].value : 0
    //     this.name = params.name
    //     this.dialogVisible = true
    //     // if (isNaN(params.value)) {
    //     //   this.showMember = false
    //     // } else {
    //     //   this.showMember = true
    //     // }
    //   })
    // })
  }

  async detail (type: string) {
    console.log(type)
    await this.manager.getProvinceData(this.name, type)
    this.showUnitList = true
  }

  jump (url: string) {
    console.log(url)
    if (url) {
      window.open(url)
    } else {
      this.$message.success('单位网站暂未开放')
    }
  }
}
